// extracted by mini-css-extract-plugin
export default {"title":"Fav_title__Q4OLk","img":"Fav_img__DI-LD"};